import React, { useEffect } from 'react'
import './index.scss'
import HelpDeskQuestionForm from '@Scenes/HelpScene/HelpDeskQuestionForm'
import ContactUsHeader from '@Components/ContactUsHeader'
import ContactUsFooter from '@Components/ContactUsFooter'
import { analyticsSendPage } from '@App/common/utils/analytics-utils'

const HelpScene = () => {
    useEffect(() => {
        analyticsSendPage('help')
    }, [])

    return (
        <>
            <title>Help</title>
            <main className="help-scene">
                <div className="global-container">
                    <ContactUsHeader />
                    <HelpDeskQuestionForm />
                    <ContactUsFooter />
                </div>
            </main>
        </>
    )
}
export default HelpScene
